import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DevicePatch, TokenPatch } from './tokenregistratie.model';

@Injectable({ providedIn: 'root' })
export class TokenregistratieResource {
    private readonly baseUrl: string = '/services/apic-tokenregistratie/api';

    public constructor(private readonly httpClient: HttpClient) {}

    public patchToken(id: string, token: TokenPatch, authenticationTaskId?: string): Observable<HttpResponse<void>> {
        let headers = new HttpHeaders().append('Content-Type', 'application/merge-patch+json');
        if (authenticationTaskId) {
            headers = headers.append('X-Authentication-Task-Id', authenticationTaskId);
        }
        return this.httpClient.patch<void>(`${this.baseUrl}/tokens/${id}`, token, {
            observe: 'response',
            headers
        });
    }

    public patchDevice(id: string, device: DevicePatch, authenticationTaskId?: string): Observable<HttpResponse<void>> {
        let headers = new HttpHeaders().append('Content-Type', 'application/merge-patch+json');
        if (authenticationTaskId) {
            headers = headers.append('X-Authentication-Task-Id', authenticationTaskId);
        }
        return this.httpClient.patch<void>(`${this.baseUrl}/devices/${id}`, device, {
            observe: 'response',
            headers
        });
    }
}
